import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Spin } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getConfig, saveConfig } from '../services/api';

const { Title, Text } = Typography;

const Login = () => {
  const { login, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState('');
  const [apiUrl, setApiUrl] = useState('');
  const [showSettings, setShowSettings] = useState(false);
  
  // 如果已经登录，重定向到首页或之前尝试访问的页面
  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
    
    // 加载配置
    const config = getConfig();
    setApiUrl(config.workerUrl || 'https://warehouseapi.proxypool.eu.org');
  }, [isAuthenticated, navigate, location]);
  
  // 处理登录
  const handleLogin = async (values) => {
    setError('');
    try {
      await login(values.username, values.password);
    } catch (error) {
      setError(error.message || '登录失败，请检查用户名和密码');
    }
  };
  
  // 保存API设置
  const handleSaveSettings = () => {
    saveConfig({ workerUrl: apiUrl });
    setShowSettings(false);
  };
  
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: '#f0f2f5'
    }}>
      <Card 
        style={{ 
          width: 400, 
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          borderRadius: '8px'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2} style={{ marginBottom: 8 }}>📦 仓库管理系统</Title>
          <Text type="secondary">请登录您的账户</Text>
        </div>
        
        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 24 }}
          />
        )}
        
        <Spin spinning={loading}>
          <Form
            name="login"
            initialValues={{ remember: true }}
            onFinish={handleLogin}
            size="large"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: '请输入用户名' }]}
            >
              <Input 
                prefix={<UserOutlined />} 
                placeholder="用户名" 
              />
            </Form.Item>
            
            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input.Password 
                prefix={<LockOutlined />} 
                placeholder="密码" 
              />
            </Form.Item>
            
            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                style={{ width: '100%' }}
                loading={loading}
              >
                登录
              </Button>
            </Form.Item>
          </Form>
        </Spin>
        
        <div style={{ textAlign: 'center' }}>
          <Button 
            type="link" 
            onClick={() => setShowSettings(!showSettings)}
          >
            {showSettings ? '隐藏设置' : '高级设置'}
          </Button>
        </div>
        
        {showSettings && (
          <div style={{ marginTop: 16 }}>
            <Form layout="vertical">
              <Form.Item label="API服务器地址">
                <Input 
                  value={apiUrl}
                  onChange={(e) => setApiUrl(e.target.value)}
                  placeholder="例如: https://warehouseapi.proxypool.eu.org"
                />
              </Form.Item>
              <Form.Item>
                <Button 
                  type="primary" 
                  onClick={handleSaveSettings}
                >
                  保存设置
                </Button>
              </Form.Item>
            </Form>
          </div>
        )}
      </Card>
    </div>
  );
};

export default Login;
